module.exports = __webpack_public_path__ + "static/img/news9.5cedf36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/news/news9.jpg
// module id = 2bTp
// module chunks = 1